import { motion } from "framer-motion";
import { MessagesSquare } from "lucide-react";
import { Reveal, SectionHead, EASE } from "./Reveal";

const QUESTIONS = [
  "Qual è la prossima scadenza?",
  "Ho consegnato tutto quello che serve?",
  "A che punto è il mio adempimento?",
  "Dove trovo quel documento?",
  "Chi può darmi una risposta chiara e affidabile?",
];

export default function Problema() {
  return (
    <section id="perche-human-factor" data-testid="section-problema" className="relative overflow-hidden py-24 lg:py-32">
      <div className="pointer-events-none absolute right-[-8%] top-[25%] h-[420px] w-[420px] rounded-full bg-[#1B6EF3]/10 blur-[130px]" />
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
        <div className="flex flex-col gap-7">
          <SectionHead
            eyebrow="Perché Human Factor"
            title={
              <>
                Il regime è forfettario. <span className="text-gradient">Le preoccupazioni, spesso, no.</span>
              </>
            }
            sub="Quando lavori in proprio non devi soltanto occuparti dei tuoi clienti e far crescere la tua attività. Devi anche ricordare scadenze, gestire documenti, rispettare gli adempimenti e capire che cosa fare ogni volta che cambia qualcosa."
          />
          <Reveal delay={0.2}>
            <p className="max-w-xl text-base leading-relaxed text-slate-400 sm:text-lg">
              Human Factor nasce per eliminare questa complessità e trasformare la gestione della Partita IVA in un
              percorso più semplice, comprensibile e organizzato.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="font-display text-xl font-bold leading-snug sm:text-2xl">
              Meno tempo dedicato alla burocrazia.{" "}
              <span className="text-gradient">Più tempo per il tuo lavoro.</span>
            </p>
          </Reveal>
        </div>

        <div className="flex flex-col items-stretch gap-3.5 lg:items-end">
          {QUESTIONS.map((q, i) => (
            <motion.div
              key={q}
              initial={{ opacity: 0, x: i % 2 === 0 ? 48 : -48 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.65, delay: i * 0.09, ease: EASE }}
              className={`glow-card flex w-fit max-w-full items-center gap-3 rounded-2xl px-5 py-4 ${
                i % 2 === 0 ? "self-start" : "self-end text-right"
              }`}
              data-testid={`problema-domanda-${i}`}
            >
              <MessagesSquare className="h-4 w-4 shrink-0 text-cyan-300" />
              <span className="font-display text-sm font-semibold text-slate-200 sm:text-base">{q}</span>
            </motion.div>
          ))}
          <motion.div
            initial={{ opacity: 0, scale: 0.92 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6, delay: 0.5, ease: EASE }}
            className="mt-2 flex w-fit items-center gap-3 self-center rounded-2xl bg-gradient-to-r from-[#1B6EF3] to-[#19D6E8] px-6 py-4 shadow-xl shadow-blue-500/30"
            data-testid="problema-risposta"
          >
            <span className="font-display text-base font-bold text-white sm:text-lg">
              Human Factor risponde a tutte.
            </span>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
